import { render, staticRenderFns } from "./change-avatar-dialog.vue?vue&type=template&id=30704498&"
import script from "./change-avatar-dialog.vue?vue&type=script&lang=js&"
export * from "./change-avatar-dialog.vue?vue&type=script&lang=js&"
import style0 from "./change-avatar-dialog.vue?vue&type=style&index=0&id=30704498&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports